import { render, staticRenderFns } from "./authorized-layout.vue?vue&type=template&id=4375507e&lang=pug"
import script from "./authorized-layout.vue?vue&type=script&lang=js"
export * from "./authorized-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports